export const formatTotpSecret = (secret: string) => {
	// Format the secret into 4 character groups converted to lowercase
	return secret
		.replace(/(.{4})/g, '$1 ')
		.toLowerCase()
		.trim();
};

export const getDeviceInfo = () => {
	const ua = navigator.userAgent;
	const isMobile = /Mobi/i.test(ua);
	const isAndroid = /Android/i.test(ua);
	const isTablet = /Tablet|iPad/i.test(ua);
	const isDesktop = !isMobile && !isTablet;

	const isWindows = /Windows/i.test(ua);
	const isMac = /Mac OS/i.test(ua);

	let info = isWindows ? 'Windows' : isMac ? 'Apple' : '';
	if (isDesktop) {
		info += ' Desktop';
	} else if (isMobile) {
		info += isMac ? ' iPhone' : isAndroid ? ' Android' : ' Mobile';
	} else if (isTablet) {
		info += ' Tablet';
	}

	return info.trim();
};
